import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { OrgProfileModal } from '../../../modules/org-profile/modal/org-profile-modal';
import { BranchModel } from '../../../modules/branch/model/branch-model';
import { LocationMasterModel } from '../../../modules/location/model/location-master-model';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { ToastrService } from 'ngx-toastr';
import { CommonSelectListService } from '../../service/common-select-list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModuleParamCBLModel } from '../modal/module-param-cblmodel';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

@Component({
  selector: 'app-cblselection',
  templateUrl: './cblselection.component.html',
  styleUrls: ['./cblselection.component.css'],
})
export class CBLSelectionComponent extends AbstractBaseDetailsComponent implements OnInit, OnChanges {
  @Input() selectedCompany: OrgProfileModal;
  @Input() selectedBranch: BranchModel;
  @Input() selectedLocation: LocationMasterModel;
  @Input() withOwnershipHeader: boolean = true;
  @Input() cblTitle: string;
  @Input() fullWidth: boolean;

  /***
   * Company branch support the company and branch combine together
   * form company branch and location will come
   * **/
  @Input('company_branch_support') isCompanyBranchCombination: boolean;

  /***Form Validation check***/
  @Input() submitted: boolean;
  @Input() isUpdateComponent: boolean;

  /***
   * Branch <-> Location relation dropdown.
   *  **/
  @Input('branch_location_support') isBranchLocationCombination: boolean;

  /***Form Group**/
  cblFormGroup: FormGroup;

  /***List Variable**/
  companyList: Array<OrgProfileModal>;
  branchList: Array<BranchModel>;
  locationList: Array<LocationMasterModel>;

  /**System Requirement **/
  moduleParamModel: ModuleParamCBLModel = new ModuleParamCBLModel(this.moduleParamConfigGlob);

  /** Change event of all dropdown */
  @Output('onCompanyChange') public onCompanyChange: EventEmitter<any> = new EventEmitter<any>();
  @Output('onBranchChange') public onBranchChange: EventEmitter<any> = new EventEmitter<any>();
  @Output('onLocationChange') public onLocationChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public toaster: ToastrService,
    private moduleParamConfigGlob: ModuleParamGlobConfigService,
    private formBuilder: FormBuilder,
    private commonService: CommonSelectListService,
    private cd: ChangeDetectorRef
  ) {
    super(toaster);
  }

  ngOnChanges(changes: SimpleChanges) {
    /*console.log(changes);
    if (changes.selectedCompany) {
      /!*if (!changes.selectedCompany.currentValue && this.isUpdateComponent) {
        this.getDefaultCompanyList(true);
      }*!/
      if (changes.selectedCompany.currentValue) {
        this.selectedCompany = new OrgProfileModal();
        this.selectedCompany = changes.selectedCompany.currentValue;
        this.cd.detectChanges();
      }
    }
    if (changes.selectedBranch) {
      /!*if (!changes.selectedBranch.currentValue) {
        this.selectedBranch = new BranchModel();
      }*!/
      if (changes.selectedBranch.currentValue) {
        this.selectedBranch = new BranchModel();
        this.selectedBranch = changes.selectedBranch.currentValue;
      }
    }
    if (changes.selectedLocation) {
      /!*if (!changes.selectedLocation.currentValue) {
        this.selectedLocation = new LocationMasterModel();
      }*!/
      if (changes.selectedLocation.currentValue) {
        this.selectedLocation = new LocationMasterModel();
        this.selectedLocation = changes.selectedLocation.currentValue;
      }
    }*/
  }

  ngOnInit() {
    this.setValidation();
    if (!this.isUpdateComponent) this.getDefaultCompanyList(true);
  }

  /**Form Validation Start**/
  setValidation() {
    this.cblFormGroup = this.formBuilder.group({
      company: [{ value: '', disabled: this.isUpdateComponent }, Validators.required],
      branch: [{ value: '', disabled: this.isUpdateComponent }, Validators.required],
      location: [{ value: '', disabled: this.isUpdateComponent }, Validators.required],
    });
    this.moduleParamValidation();
  }

  //ToDo need to take this part to core level
  moduleParamValidation() {
    Object.keys(this.cblFormGroup.controls).forEach((key, index) => {
      const object = this.moduleParamModel.paramData[`${key}`];
      const isRequired = object ? object.isRequired : undefined;
      const required = isRequired == undefined ? true : isRequired;
      if (object) {
        this.utilConfigCheckFormValidation(this.cblFormGroup, key, required);
      }
    });
  }

  utilConfigCheckFormValidation(formGroup: FormGroup, name: string, required: boolean) {
    // formGroup.get(`${name}`).clearValidators();
    if (required) {
      formGroup.get(`${name}`).setValidators([Validators.required]);
    } else {
      formGroup.get(`${name}`).setValidators([]);
    }
    formGroup.get(`${name}`).updateValueAndValidity();
  }

  get f() {
    return this.cblFormGroup.controls;
  }
  /**Form Validation End **/

  /**
   *List Calling selection start
   ***/
  getDefaultCompanyList(refresh: boolean) {
    if (!this.selectedCompany || refresh) {
      this.commonService.getOrganizationData().subscribe((response) => {
        this.validateResponse(response, () => {
          this.selectedCompany = new OrgProfileModal();
          this.selectedCompany = response.data;
          this.getBranchFromCompanySelection();
        });
      });
    }
  }

  getCompanyList(refresh: boolean) {
    if (!this.companyList || this.companyList.length === 0 || refresh) {
      this.commonService.getOrganizationList().subscribe((response) => {
        this.validateResponse(response, () => {
          this.companyList = new Array<OrgProfileModal>();
          this.companyList = response.dataList;
          this.companyList = response.dataList.filter((ls) => !ls.party);
          // this.getBranchFromCompanySelection();
        });
      });
    }
  }

  getBranchFromCompanySelection() {
    this.onCompanyChange.emit({ data: this.selectedCompany });
    this.branchList = new Array<BranchModel>();
    if (this.isBranchLocationCombination) {
      this.locationList = new Array<LocationMasterModel>();
      this.selectedLocation = undefined;
    }
    this.selectedBranch = undefined;
    this.selectedLocation = undefined;
    if (!this.isCompanyBranchCombination) {
      if (
        this.selectedCompany &&
        this.selectedCompany.branchDetails &&
        this.selectedCompany.branchDetails.length !== 0
      ) {
        this.branchList = this.selectedCompany.branchDetails.map((brch) => brch.branch);
        const defaultEntry = this.selectedCompany.branchDetails.find((defBrch) => defBrch.isDefault);
        this.selectedBranch = new BranchModel();
        this.selectedBranch = defaultEntry.branch;
        this.selectedLocation = new LocationMasterModel();
        this.selectedLocation = defaultEntry.branchDetailsLocation.find((defLoc) => defLoc.isDefault).location;
      }
    } else {
      this.isBranchLocationCombination = false;
      this.getBranchList(false);
    }
  }

  getBranchList(refresh: boolean) {
    if (!this.branchList || this.branchList.length == 0 || refresh) {
      this.commonService.getBranchList().subscribe((response) => {
        this.validateResponse(response, () => {
          this.branchList = new Array<BranchModel>();
          this.branchList = response.dataList;
        });
      });
    }
  }

  getLocationList(refresh: boolean) {
    if (this.isBranchLocationCombination || refresh) {
      this.getLocationFormBranch(false);
      return;
    }
    if (!this.locationList || this.locationList.length == 0 || refresh) {
      this.commonService.getLocationList().subscribe((response) => {
        this.validateResponse(response, () => {
          this.locationList = new Array<LocationMasterModel>();
          this.locationList = response.dataList;
          this.locationList = this.locationList.filter((ls) => !ls.party);
        });
      });
    }
  }

  getLocationFormBranch(defaultCheck: boolean) {
    this.onBranchChange.emit({ data: this.selectedBranch });
    if (!this.isBranchLocationCombination) return;
    this.locationList = new Array<LocationMasterModel>();
    if (defaultCheck) this.selectedLocation = undefined;
    if (this.selectedBranch) {
      let branch = this.selectedCompany.branchDetails.find((ls) => ls.branch && ls.branch.id == this.selectedBranch.id);
      if (branch) {
        this.locationList = JSON.parse(JSON.stringify(branch.branchDetailsLocation.map((loc) => loc.location)));
        if (defaultCheck) this.selectedLocation = branch.branchDetailsLocation.find((loc) => loc.isDefault).location;
      }
    }
  }
  /**
   *List Calling selection End
   ***/

  /** Location Change Event */

  locationChange() {
    this.onLocationChange.emit({ data: this.selectedLocation });
  }
}
